import Vue from "vue"
import App from "./App.vue"
import VueRouter from 'vue-router'
import * as VueGoogleMaps from 'vue2-google-maps'
// import * as data from './components/static/data.json'

// vue router templates
import HighlightsComp from './components/map/mapHighlights.vue'
import AboutComp from './components/map/mapAbout.vue'
import ItineraryNodeComp from './components/map/mapItineraryNode.vue'

// let dataArr = JSON.stringify(data)
// dataArr = JSON.parse(dataArr)

// fetch data
// Api call example: /Api/ListApi/GetItineraryHighlights?nodeid=144



Vue.use(VueRouter)

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyAC8xrUK_qokBAWoaaXbNB10-yUGnfWUxc',
		libraries: 'places',
	},
	installComponents: true
})

const routes = [
	{
		path: '/',
		redirect: { name: 'highlight' },
	},
	{
		path: '/highlight',
		name: 'highlight',
		component: HighlightsComp,
		// props: () => ({ dataArr: dataArr.default}),
	},
	{
		path: '/highlight/:node',
		name: 'itinerary-node',
		component: ItineraryNodeComp,
		// props: (route) => ({ dataObj: dataArr.default, route: route })
	},
	{
		path: '/about',
		name: 'about',
		component: AboutComp,
		// props: () => ({ aboutObj: dataArr.default.about }),
	}
]

const router = new VueRouter({
	routes
})

Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App),
}).$mount("#app")